import { useSearchParams } from "react-router-dom";

export const useParam = (name, def) => useSearchParams()[0].get(name) || def;
export const useAba = (def) => useParam("aba", def);
